import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63d20d4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "dialog-title"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "dialog-title"
}
const _hoisted_5 = { class: "text-center" }

import { ref, onUnmounted } from 'vue'
import Icon from './IconUI.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogUI',
  props: {
  id: { type: String, default: '' },
  title: { type: String, default: '' },
  size: { type: String, default: '' },
  scrollable: { type: Boolean, default: false },
  dismissible: { type: Boolean, default: false },
},
  emits: ["dialog-closed"],
  setup(__props, { expose: __expose, emit }) {



const isVisible = ref(false)


onUnmounted(() => {
  document.body.style.overflow = 'auto'
})

function show() {
  isVisible.value = true
  document.body.style.overflow = 'hidden'
}

function hide() {
  isVisible.value = false
  document.body.style.overflow = 'auto'
  emit('dialog-closed')
}

__expose<IDialogUI>({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.id,
    class: _normalizeClass(["dialog-container", { visible: isVisible.value }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["dialog", [__props.size, { scrollable: __props.scrollable }]])
    }, [
      (__props.dismissible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(Icon, {
              class: "dialog-close-icon",
              "data-testid": "closeIcon",
              name: "close",
              fill: "body",
              onClick: hide
            }),
            (__props.title)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(__props.title), 1))
              : _createCommentVNode("", true)
          ]))
        : (__props.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(__props.title), 1)
            ]))
          : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 10, _hoisted_1))
}
}

})